var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG1Siren(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#G1_Siren_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.94 38a22.51 22.51 0 01-6.56 15.68L66.62 51a18.77 18.77 0 005.51-13 18.76 18.76 0 00-5.51-13l2.76-2.63A22.53 22.53 0 0175.94 38zm-10.75-8.83l-3.3 2A13.12 13.12 0 0164 38a13.1 13.1 0 01-2.14 6.77l3.3 2A16.82 16.82 0 0067.9 38a16.87 16.87 0 00-2.71-8.83zm-14.06-.11L56.41 56H44v1.28A2.72 2.72 0 0141.28 60h-6.56A2.72 2.72 0 0132 57.28V56H19.6l5.28-27c1.29-7 6.69-11.83 13.12-11.83 6.43 0 11.83 4.91 13.13 11.89zM51.5 52l-4.34-22.15c-.94-5-4.7-8.56-9.16-8.56s-8.22 3.52-9.15 8.56L24.51 52H51.5zM10.76 29.17A17 17 0 008 38a16.91 16.91 0 002.71 8.78l3.3-2A13.1 13.1 0 0111.92 38a13.12 13.12 0 012.14-6.77l-3.3-2.06zM9.33 24.9l-2.76-2.63A22.53 22.53 0 000 38a22.51 22.51 0 006.57 15.63L9.33 51a18.77 18.77 0 01-5.51-13 18.76 18.76 0 015.51-13.1z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "G1_Siren_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h76v76H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/G1_Siren.cb448bd2.svg";
export { SvgG1Siren as ReactComponent };